<template>
	<header data-elementor-type="header" data-elementor-id="2387" class="elementor elementor-2387 elementor-location-header" data-elementor-post-type="elementor_library">
		<div class="elementor-element elementor-element-47be1ff5 elementor-hidden-tablet elementor-hidden-mobile e-flex e-con-boxed e-con e-parent" data-id="47be1ff5" data-element_type="container" data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}" data-core-v316-plus="true">
			<div class="e-con-inner">
				<div class="elementor-element elementor-element-14b78cf3 e-con-full e-flex e-con e-child" data-id="14b78cf3" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;,&quot;container_type&quot;:&quot;flex&quot;}">
					<div class="elementor-element elementor-element-f3cb7 elementor-widget elementor-widget-image" data-id="f3cb7" data-element_type="widget" data-widget_type="image.default">
						<div class="elementor-widget-container">
							<style>
								/*! elementor - v3.19.0 - 05-02-2024 */
								.elementor-widget-image {
									text-align: center
								}

									.elementor-widget-image a {
										display: inline-block
									}

										.elementor-widget-image a img[src$=".svg"] {
											width: 48px
										}

									.elementor-widget-image img {
										vertical-align: middle;
										display: inline-block
									}
							</style>											<a href="https://www.zeleris.com">
								<img src="https://www.zeleris.com/wp-content/uploads/2023/12/LOGO-HORIZONTAL.svg" title="logotipo-zeleris" alt="logotipo-zeleris" loading="lazy" />
							</a>
						</div>
					</div>
				</div>


			</div>

		</div>
		<div class="elementor-element elementor-element-500ff5e elementor-hidden-desktop e-flex e-con-boxed e-con e-parent" data-id="500ff5e" data-element_type="container" data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}" data-core-v316-plus="true">
			<div class="e-con-inner">
				<div class="elementor-element elementor-element-c4561d9 e-con-full e-flex e-con e-child" data-id="c4561d9" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;,&quot;container_type&quot;:&quot;flex&quot;}">
					<div class="elementor-element elementor-element-86a7f02 elementor-widget elementor-widget-image" data-id="86a7f02" data-element_type="widget" data-widget_type="image.default">
						<div class="elementor-widget-container">
							<a href="https://www.zeleris.com">
								<img src="https://www.zeleris.com/wp-content/uploads/2023/12/LOGO-HORIZONTAL.svg" title="logotipo-zeleris" alt="logotipo-zeleris" loading="lazy" />
							</a>
						</div>
					</div>
					<div class="elementor-element elementor-element-f72fbf0 elementor-nav-menu__text-align-center elementor-widget-mobile__width-inherit menu-responsive elementor-nav-menu--stretch elementor-nav-menu--toggle elementor-nav-menu--burger elementor-widget elementor-widget-nav-menu" data-id="f72fbf0" data-element_type="widget" data-settings="{&quot;layout&quot;:&quot;dropdown&quot;,&quot;submenu_icon&quot;:{&quot;value&quot;:&quot;&lt;svg class=\&quot;fa-svg-chevron-down e-font-icon-svg e-fas-chevron-down\&quot; viewBox=\&quot;0 0 448 512\&quot; xmlns=\&quot;http:\/\/www.w3.org\/2000\/svg\&quot;&gt;&lt;path d=\&quot;M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z\&quot;&gt;&lt;\/path&gt;&lt;\/svg&gt;&quot;,&quot;library&quot;:&quot;fa-solid&quot;},&quot;full_width&quot;:&quot;stretch&quot;,&quot;toggle&quot;:&quot;burger&quot;}" data-widget_type="nav-menu.default">
						<div class="elementor-widget-container">
							<link rel="stylesheet" href="https://www.zeleris.com/wp-content/plugins/elementor-pro/assets/css/widget-nav-menu.min.css">		<div class="elementor-menu-toggle" role="button" tabindex="0" aria-label="Alternar men�" aria-expanded="false">
								<svg aria-hidden="true" role="presentation" class="elementor-menu-toggle__icon--open e-font-icon-svg e-eicon-menu-bar" viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg"><path d="M104 333H896C929 333 958 304 958 271S929 208 896 208H104C71 208 42 237 42 271S71 333 104 333ZM104 583H896C929 583 958 554 958 521S929 458 896 458H104C71 458 42 487 42 521S71 583 104 583ZM104 833H896C929 833 958 804 958 771S929 708 896 708H104C71 708 42 737 42 771S71 833 104 833Z"></path></svg><svg aria-hidden="true" role="presentation" class="elementor-menu-toggle__icon--close e-font-icon-svg e-eicon-close" viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg"><path d="M742 167L500 408 258 167C246 154 233 150 217 150 196 150 179 158 167 167 154 179 150 196 150 212 150 229 154 242 171 254L408 500 167 742C138 771 138 800 167 829 196 858 225 858 254 829L496 587 738 829C750 842 767 846 783 846 800 846 817 842 829 829 842 817 846 804 846 783 846 767 842 750 829 737L588 500 833 258C863 229 863 200 833 171 804 137 775 137 742 167Z"></path></svg>			<span class="elementor-screen-only">Men�</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>


		<nav id="main_nav">
			<p class="nav_sections"></p>
		</nav>
	</header>

</template>

<script>
    export default {
        computed: {
            esMovil () { return this.$vuetify.breakpoint.smAndDown }
        }
    }
</script>

<style scoped>
html {
  font-size: 62.5% !important;
}
</style>